import { call, takeEvery, takeLatest } from 'redux-saga/effects';

import * as constants from './notifications.constants';
import * as types from './notifications.types';
import * as services from './notifications.saga-services';

function* invokeSetupNotifications(action: types.IFetchNotifications) {
  yield call(services.setupNotifications);
}

function* invokeHandleNewNotification(action: types.IHandleNewNotification) {
  yield call(services.handleNewNotificationNotification, action.payload);
}

function* invokeSaveDueDate(action: types.ISaveDueDate) {
  yield call(services.handleNewNotificationNotification, action.payload);
}

function* invokeSaveMembers(action: types.ISaveMembers) {
  yield call(services.handleNewNotificationNotification, action.payload);
}

function* invokeSaveActivity(action: types.ISaveActivity) {
  yield call(services.handleNewNotificationNotification, action.payload);
}

function* invokeSaveChecklist(action: types.ISaveChecklist) {
  yield call(services.handleNewNotificationNotification, action.payload);
}

function* invokeupdateNotificationsStatus(action: types.IUpdateNotificationsStatus) {
  yield call(services.updateNotificationsStatus, action.payload);
}

export function* watchNotificationsPageSaga() {
  yield takeLatest(constants.FETCH_NOTIFICATIONS, invokeSetupNotifications);
  yield takeEvery(constants.HANDLE_NEW_NOTIFICATION, invokeHandleNewNotification);
  yield takeEvery(constants.ACTION_SAVE_DUE_DATE, invokeSaveDueDate);
  yield takeEvery(constants.ACTION_SAVE_MEMBERS, invokeSaveMembers);
  yield takeEvery(constants.ACTION_SAVE_ACTIVITY, invokeSaveActivity);
  yield takeEvery(constants.ACTION_SAVE_CHECKLIST, invokeSaveChecklist);
  yield takeEvery(constants.UPDATE_NOTIFICATIONS_STATUS, invokeupdateNotificationsStatus);
}
